import React, { Component } from "react";
import { Col, Card, CardBody, CardText, CardTitle } from "reactstrap";

import img from "../../assets/images/parlament.jpg";
import "../../styles/features/Home/HomeNews.css";
import LoadMore from "../../components/LoadMore";
import { withRouter } from "react-router";

class HomeNews extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  transform = data => {
    let lang = localStorage.getItem("language");
    if (lang === "en") {
      data = data.map(news => {
        console.log("here");
        news.Titulli = news.TitulliEn;
        news.NenTitulli = news.NenTitulliEn;
        news.Permbajtja = news.PermbajtjaEn;
        return news;
      });
    }
    return data;
  };
  normal = () => {
    let data = this.transform(this.props.data);

    return (
      <div className="HomeNews" id="HomeNews">
        <div className="NewsTitle">
          <h3>Lajmet Kryesore</h3>
        </div>
        {data.map(News => {
          console.log(News);
          var w = window.innerWidth;
          var titulli = News.Titulli;
          if (titulli && w < 411) {
            if (titulli.length > 30) {
              titulli = titulli.slice(0, 30);
            }
          }
          return (
            <Col lg={12} md={10} sm={12} xs={12} className="mb-3">
              <Card
                className="flex-row materialNews"
                style={{ height: 150, overflow: "hidden" }}
              >
                <div className="img-cont img-cont-home">
                  <img className="card-img-left" src={img} alt="" />
                  {/* <div class="top-left ">{News.Struktura.Emri}</div> */}
                  {News.DateKrijuar ? (
                    <div className="bottom-right">
                      {News.DateKrijuar.slice(0, 20)}
                    </div>
                  ) : (
                    <div className="bottom-right">{"-"}</div>
                  )}
                </div>
                <CardBody className="index-body">
                  <CardTitle className="cardTitle index-home">
                    {titulli}
                  </CardTitle>

                  <div className="readMoreRight">
                    <LoadMore history={this.props.history} id={News.ID} />
                  </div>
                </CardBody>
              </Card>
            </Col>
          );
        })}
        <div className="SeeMoreOnEnd">
          <button
            onClick={() => {
              this.props.history.push("news");
            }}
            class="buttonSeeMore"
          >
            Shiko Me Shume
          </button>
        </div>
      </div>
    );
  };

  render() {
    console.log(this.props, "props");
    return this.normal();
  }
}

export default withRouter(HomeNews);
